/* eslint-disable camelcase */
export default {
	OU_subject: 'OU subject',
	founder: 'Creator',
	isEnabled: '是否生效',
	Subject_category: 'Subject category',
	Whether_to_upload_business_license: 'Is upload business license ?',
	Whether_to_upload_legal_person_certificate: 'Is upload legal person certificate ?',
	update_time: 'Update time',
	last_update_by: 'Lastest updated by',
	actions: 'Actions',
	query_condition: 'Query Conditions',
	please_input_ou_subject: 'please select or search OU subject',
	please_input_creator: 'please input creator',
	subject_status: 'Subject status',
	please_input_subject_status: 'please select subject status',
	legal_person_status: 'Legal person status',
	please_input_legal_person_status: 'please input legal person status',
	query_result: 'Query Result',
	subject_maintain: 'Subject maintain',
	legal_person_maintain: 'Legal person maintain',
	submit_work: 'Submit & Work',
	ou_exist_tip: 'The subject information has been entered, please select another subject',
	cannot_find_ou_subject_info: 'The subject qualification information could not be found',
	subject_basic_info: 'Subject Basic Information',
	ou_code: 'OU code',
	please_input_ou_code: 'please input OU code',
	ou_subject_all: 'OU subject (full name)',
	please_select_subject_category: 'please input subject category',
	company_name: 'Company name',
	please_input_company_name: 'please input company name',
	reg_country: 'Country of registration',
	please_select_reg_country: 'please select country of registration',
	reg_address: 'Registered address',
	please_input_reg_address: 'please input registered address',
	obtained_uscc: 'Obtained uscc?',
	please_select_obtained_uscc: 'please select whether obtained uscc',
	is_finance_institution: 'Is finanece institution?',
	please_select_is_finance_institution: 'please select whether finanece institution',
	finance_type: 'Finance type',
	please_select_finance_type: 'please select finance type',
	biz_scope: 'Business Scope',
	please_input_biz_scope: 'please input business scope',
	subject_detail_info: 'Subject Qualification Detail Information',
	new_certificate: 'New Certificate',
	qua_doc_type: 'Qualification document type',
	please_select_qua_doc_type: 'please select qualification document type',
	union_code: 'Unified social credit code',
	please_input_union_code: 'please input unified social credit code',
	qualification_attachments: 'Qualification attachments',
	please_select_date: 'please select date',
	cert_num: 'Certificate number',
	delete_cert: 'Delete certificate',
	subject_bank_info: 'Subject Bank Info',
	account_name: 'Account name',
	please_input_account_name: 'please input account name',
	account_type: 'Account type',
	please_select_account_type: 'please select account type',
	account_num: 'Account No.',
	please_input_account_num: 'please input account no.',
	bank_belone_country: 'Country',
	please_select_bank_country: 'please input country',
	bank_province: 'province',
	please_select_province: 'please select province',
	bank_city: 'City',
	please_select_bank_city: 'please inpu city',
	bank: 'Bank name',
	please_select_bank: 'please input bank name',
	branch_bank_name: 'Branch bank name',
	branch_bank_name_tip_1:
		'The full name of the bank needs to be filled in, such as "Shenzhen Rural Commercial Bank XXX Sub-branch", see for details ',
	branch_bank_name_tip_2: ' full name of the deposit bank (including sub-branch) comparison table',
	please_input_bank_full_name: 'Please input the full name of the bank',
	cnaps_code: 'Cnaps code',
	bank_branch_id: 'Bank branch id',
	please_input_cnaps_code: 'please input cnaps code',
	cnaps_code_or_branch_bank: 'Fill in the full name of the deposit bank or the UnionPay number',
	id_holder_type: 'Id holder type',
	plz_id_holder_type: 'please select id holder type',
	is_owner: 'Is owner?',
	plz_is_owner: 'please select "is owner?"',
	id_doc_type: 'Id document type',
	plz_id_doc_type: 'please select id document type',
	person_name: 'Person name',
	plz_person_name: 'please input person name',
	cert_name: 'Certificate name',
	plz_cert_name: 'please input certificate type',
	cert_number: 'Certificate number',
	plz_cert_number: 'please input certificate number',
	front_view_pic: 'Front view picture',
	upload_front_view: 'uplood front view',
	plz_upload_front_view: 'please uplood front view',
	back_view_pic: 'Back view picture',
	upload_back_view: 'upload back view',
	plz_upload_back_view: 'please upload back view',
	cert_address: 'Certificate addres',
	plz_cert_address: 'please input certificate address',
	legal_person_info: 'Legal Person Information',
	authorize_letter: 'Authorize letter',
	bank_address_code: 'Bank address code'
};
